<!--
    props: options: array => Title, Type, Url
    emits: update-typeahead, update-search
-->
<template>
    <div :class="typeaheadState">
        <div class="typeahead__toggle" ref="toggle" @mousedown="toggle">
            <input type="text" class="typeahead__search" ref="search" title="Search Text Input"
                   v-model="search"
                   @focus="onFocus"
                   @blur="onBlur"
                   @keydown.esc="onEscapeKey"
                   @keydown.tab.prevent="processTags($event.target.value)"
                   @keydown.tab="onTab($event)"
                   @keydown.down="onDownKey"
                   @keydown.up="onUpKey"
                   @keydown.enter="onEnterKey"
                   @input="onInput"
                   placeholder="Search">

            <span class="typeahead__text" ref="text" style="visibility:hidden;display:none;">{{displayText}}</span>
            <span class="input-group-append">
                <button aria-label="Search" class="btn btn-secondary typeahead__button desktop-only" @click="onSearch" type="button" ref="btn">
                    <span class="icon-search"></span>
                </button>
            </span>
        </div>
        <div class="list-wrap" ref="list" v-if="(open && options.length > 0)">
            <ul class="typeahead__list" v-for="(option) in options">
                <li class="typeahead__item" v-for="(item) in option.Items" v-if="(item.Title.length > 0)">
                    <a class="typeahead__sublink" @mousedown.prevent="select(item)">
                        <span class="type" v-if="item.Description" v-html="copyWithHighlights(item.Description)"></span>
                        <span class="spacer" v-if="item.Description">|</span>
                        <span v-html="copyWithHighlights(item.Title)"></span>
                    </a>
                </li>
                <li class="see-all-item">
                    <a class="typeahead__link all-results" @mousedown.prevent="selectAll()">
                        See All Results for
                    </a>
                    <span class="icon icon-arrow-right"></span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            default() {
                return []
            }
        },
        currentSearchTerm: ''
    },
    data(){
        return {
            open: false,
            selectIndex: -1,
            selectIndexSub: -1,
            displayText: '',
            search: '',
            list_elements: '',
            elm_index: -1,
        }
    },
    computed: {
        typeaheadState() {
            return this.open ? 'typeahead typeahead__open' : 'typeahead typeahead__open';
        }
    },
    mounted: function () {
        this.list_elements = $('.typeahead__link, .typeahead__subitem');
        this.elm_index = -1;
        $('.typeahead__close').click((e) => e.preventDefault());
    },
    created: function() {
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);

        if (params.get('Query') !== null && params.get('Query') !== ''){
            this.search = params.get('Query');
        } else if (params.get('query') !== null && params.get('query') !== ''){
            this.search = params.get('query');
        }

    },
    methods: {
        onInput() {
            this.selectIndex = -1;
            this.selectIndexSub = -1;
            if(this.search.length > 2){
                this.$emit('update-typeahead', this.search);
            }else{
                this.$emit('update-typeahead', '');
            }
        },
        onTab(e) {
            this.list_elements = $('.typeahead__link, .typeahead__subitem');
            if(this.elm_index < this.list_elements.length -1 && !e.shiftKey) {
                this.elm_index++;
                this.SelectElm(this.elm_index);
            }
            if(this.elm_index>0 && e.shiftKey) {
                this.elm_index--;
                this.SelectElm(this.elm_index);
            }
        },
        onDownKey() {
           /* this.list_elements = $('.typeahead__link, .typeahead__subitem');
            if(this.elm_index < this.list_elements.length -1){
                this.elm_index++;
                this.SelectElm(this.elm_index);
            }*/
        },
        onUpKey() {
            /* this.list_elements = $('.typeahead__link, .typeahead__subitem');
            if(this.elm_index>0){
                this.elm_index--;
                this.SelectElm(this.elm_index);
            }*/
        },
        onEnterKey() {
            var options = [];
            this.options.forEach(x => {
                options.push(x);
                x.Items.forEach(y => {
                    options.push(y);
                });
            });
            const option = options[this.elm_index];

            if(option){
                this.select(option);
            }else{
                this.$emit('update-search', this.search);
                this.displayText = this.search;
                this.open = false;
            }
        },
        onSearch() {
            this.displayText = this.search;
            this.$emit('update-search', this.search);
        },
        selectAll(){
            this.displayText = this.search;
            this.$emit('update-search', this.search);
            this.$refs.search.blur();
        },
        select(option) {
            // go to the url
            if(option.Url){
                window.location.href = option.Url;
            }
            /*
            this.search = option.Title;
            this.displayText = this.search;
            this.$emit('update-search', this.search);
            this.$refs.search.blur();
            */
        },
        toggle(e) {
            if(e.target === this.$refs.toggle ||
                e.target === this.$refs.search ||
                e.target === this.$refs.text) {

                if(this.open) {
                    if(e.target !== this.$refs.search &&
                        e.target !== this.$refs.text){

                        this.$refs.search.blur();
                    }
                }else{
                    this.$refs.search.focus();
                }
            }
        },
        onFocus() {
            this.open = true;
        },
        onBlur() {
            this.displayText = this.search;
            this.selectIndex = -1;
            this.open = false;
        },
        onEscapeKey() {
            this.$refs.search.blur();
        },
        copyWithHighlights(copy) {
            const term = this.search; // search query we want to highlight in results
            const newCopy = copy.replace(new RegExp(term, "gi"), (match) => `<mark>${match}</mark>`);
            return newCopy;
        },
        SelectElm(elm_index){
            $('.typeahead__active').removeClass('typeahead__active');
            console.log(elm_index);
            this.list_elements = $('.typeahead__link, .typeahead__subitem');
            $(this.list_elements[this.elm_index]).addClass('typeahead__active');
        }
    }
}
</script>
